import React from 'react'
import ListMyPurchaseV2 from '_pages/Event/ListMyPurchaseV2'
// import ListMyPurchases from '_pages/Event/ListMyPurchases'

function ListMyPurchasesPage() {
  return (
    <div className='size-width-desktop-sm' style={{ paddingBottom: '20px' }}>
      <ListMyPurchaseV2 />
    </div>
  )
}

export default ListMyPurchasesPage
